import BlockedSeverityIcon from '@mui/icons-material/Cancel';
import HighSeverityIcon from '@mui/icons-material/Error';
import MediumSeverityIcon from '@mui/icons-material/RemoveCircle';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

type WarningSeverity = 'medium' | 'high' | 'blocked';

type WarningFieldProps = { text: string; severity: WarningSeverity; 'data-testid'?: string };

export const WarningField = (props: WarningFieldProps) => {
  const { text, severity, 'data-testid': dataTestId } = props;
  let color = '#FF6464';
  if (severity === 'medium') {
    color = '#E38519';
  } else if (severity === 'blocked') {
    color = 'black';
  }

  const classes = useStyles();

  return (
    <Box
      data-testid={dataTestId ?? 'BoWarningField'}
      bgcolor={color}
      color="white"
      height={28}
      display="flex"
      borderRadius="5px"
      justifyContent="center"
      alignItems="center"
      paddingLeft={3}
      paddingRight={3}
      whiteSpace="nowrap">
      {severity === 'high' && <HighSeverityIcon />}
      {severity === 'medium' && <MediumSeverityIcon />}
      {severity === 'blocked' && <BlockedSeverityIcon />}
      <Typography className={classes.text}>{text}</Typography>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  text: {
    textTransform: 'capitalize',
    paddingLeft: 5,
  },
}));
